export default {
	'graphsexport':true,
	'download': true,
	'archives': true,
	'streamPopover':{
		'enabled': true,
		'audio': true,
		'video': true,
	},
	'realtime': true,
	'measurement': {
		'enabled': true,
		'measurement': true, 
	},
	'settings':{
		'enabled': true,
		'interface':true,
		'download':true,
		'audioRecording': true,
		'dynamicDns':{
			'enabled': true,
			'address': true,
			'provider': false,
			'username': false,
			'password': false,
			'ip': true
		},
		'alertMessaging':{
			'enabled': true,
			'emailsett': true,
			'sender': true,
			'password': false,
			'smtp': false
		},
		'FTPSending':{
			'enabled': true,
			'address': true,
			'refresh': true,
			'username': false,
			'password': false,
			'port': false,
			'values': true,
			'zipped': true,
		},
		'geographicPosition':true,
		'weather':true,
		'delete':true,
		'device':true,
		'video':true,
		'adio':true,
		'norcloud':true,
		'status': {
			'enabled': true,
			'gauges': true,
			'logs': true,
			'users': true,
			'userAdmin': false,
			'userOper': true,
			'userGuest': true
		}
	},
}


// WEBPACK FOOTER //
// ./src/users/operator.js